import { render } from "./PROPOSAL_PUBLISH_BY_ORG.vue?vue&type=template&id=2f51ca97"
import script from "./PROPOSAL_PUBLISH_BY_ORG.vue?vue&type=script&lang=js"
export * from "./PROPOSAL_PUBLISH_BY_ORG.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__